// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* Light mode colors */
  --bg-main: #f5f5f5;
  --bg-card: #ffffff;
  --text-muted: #948979;
  --text-primary: #393e46;
  --border-color: #e5e7eb;

  /* Accent colors */
  --color-error: #dc2626;
  --color-success: #16a34a;

  /* Scrollbar colors */
  --scrollbar-thumb: #cbd5e1;

  /* Overlay colors */
  --overlay-light: rgba(0, 0, 0, 0.05);
  --overlay-medium: rgba(0, 0, 0, 0.1);
  --border-subtle: rgba(0, 0, 0, 0.05);

  /* Component specific */
  --btn-active-bg: rgba(148, 137, 121, 0.15);
  --input-border: rgba(148, 137, 121, 0.3);

  /* Shadows */
  --shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.1);
  --shadow-md: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --shadow-lg: 0 25px 50px -12px rgb(0 0 0 / 0.25);

  /* Border radius */
  --radius-sm: 0.25rem;
  --radius-md: 0.5rem;
  --radius-lg: 0.75rem;
  --radius-xl: 1rem;
  --radius-full: 9999px;

  /* Transitions */
  --transition-fast: 0.15s ease;
  --transition-normal: 0.2s ease;

  /* Mobile header height (padding-top + content + padding-bottom) */
  --mobile-header-height: 4.5rem;

  /* Fallback for surface used in loading-indicator */
  --surface: var(--bg-card);
}

.dark {
  --bg-main: #222831;
  --bg-card: #393e46;
  --text-muted: #b4a998;
  --text-primary: #dfd0b8;
  --border-color: #393e46;

  /* Scrollbar colors */
  --scrollbar-thumb: #334155;

  /* Overlay colors */
  --overlay-light: rgba(255, 255, 255, 0.03);
  --overlay-medium: rgba(255, 255, 255, 0.1);
  --border-subtle: rgba(255, 255, 255, 0.05);

  /* Component specific */
  --btn-active-bg: rgba(180, 169, 152, 0.2);
  --input-border: rgba(255, 255, 255, 0.15);
}
`, "",{"version":3,"sources":["webpack://./src/styles/base/variables.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,uBAAuB;EACvB,uBAAuB;;EAEvB,kBAAkB;EAClB,sBAAsB;EACtB,wBAAwB;;EAExB,qBAAqB;EACrB,0BAA0B;;EAE1B,mBAAmB;EACnB,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;;EAEpC,uBAAuB;EACvB,0CAA0C;EAC1C,wCAAwC;;EAExC,YAAY;EACZ,yCAAyC;EACzC,6EAA6E;EAC7E,gDAAgD;;EAEhD,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;;EAErB,gBAAgB;EAChB,6BAA6B;EAC7B,8BAA8B;;EAE9B,kEAAkE;EAClE,8BAA8B;;EAE9B,mDAAmD;EACnD,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,uBAAuB;EACvB,uBAAuB;;EAEvB,qBAAqB;EACrB,0BAA0B;;EAE1B,mBAAmB;EACnB,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;;EAE1C,uBAAuB;EACvB,yCAAyC;EACzC,yCAAyC;AAC3C","sourcesContent":[":root {\n  /* Light mode colors */\n  --bg-main: #f5f5f5;\n  --bg-card: #ffffff;\n  --text-muted: #948979;\n  --text-primary: #393e46;\n  --border-color: #e5e7eb;\n\n  /* Accent colors */\n  --color-error: #dc2626;\n  --color-success: #16a34a;\n\n  /* Scrollbar colors */\n  --scrollbar-thumb: #cbd5e1;\n\n  /* Overlay colors */\n  --overlay-light: rgba(0, 0, 0, 0.05);\n  --overlay-medium: rgba(0, 0, 0, 0.1);\n  --border-subtle: rgba(0, 0, 0, 0.05);\n\n  /* Component specific */\n  --btn-active-bg: rgba(148, 137, 121, 0.15);\n  --input-border: rgba(148, 137, 121, 0.3);\n\n  /* Shadows */\n  --shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.1);\n  --shadow-md: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);\n  --shadow-lg: 0 25px 50px -12px rgb(0 0 0 / 0.25);\n\n  /* Border radius */\n  --radius-sm: 0.25rem;\n  --radius-md: 0.5rem;\n  --radius-lg: 0.75rem;\n  --radius-xl: 1rem;\n  --radius-full: 9999px;\n\n  /* Transitions */\n  --transition-fast: 0.15s ease;\n  --transition-normal: 0.2s ease;\n\n  /* Mobile header height (padding-top + content + padding-bottom) */\n  --mobile-header-height: 4.5rem;\n\n  /* Fallback for surface used in loading-indicator */\n  --surface: var(--bg-card);\n}\n\n.dark {\n  --bg-main: #222831;\n  --bg-card: #393e46;\n  --text-muted: #b4a998;\n  --text-primary: #dfd0b8;\n  --border-color: #393e46;\n\n  /* Scrollbar colors */\n  --scrollbar-thumb: #334155;\n\n  /* Overlay colors */\n  --overlay-light: rgba(255, 255, 255, 0.03);\n  --overlay-medium: rgba(255, 255, 255, 0.1);\n  --border-subtle: rgba(255, 255, 255, 0.05);\n\n  /* Component specific */\n  --btn-active-bg: rgba(180, 169, 152, 0.2);\n  --input-border: rgba(255, 255, 255, 0.15);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
